module.exports = __webpack_public_path__ + "media/images/orange-sound-fb01214d50cdb34eb5a409aadfbf9f81.png";